/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ToolMetadataForm,
  ToolMetadataForm$Outbound,
  ToolMetadataForm$outboundSchema,
} from "./toolmetadataform.js";

export type SetToolMetadataBatchRequestBody = {
  /**
   * The ID of the MCP server the tool metadata belongs to
   */
  mcpServerId: string;
  /**
   * The authoritative set of tools for the MCP server. Stored tools absent from this list are soft-deleted.
   */
  tools: Array<ToolMetadataForm>;
};

/** @internal */
export type SetToolMetadataBatchRequestBody$Outbound = {
  mcp_server_id: string;
  tools: Array<ToolMetadataForm$Outbound>;
};

/** @internal */
export const SetToolMetadataBatchRequestBody$outboundSchema: z.ZodMiniType<
  SetToolMetadataBatchRequestBody$Outbound,
  SetToolMetadataBatchRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    tools: z.array(ToolMetadataForm$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function setToolMetadataBatchRequestBodyToJSON(
  setToolMetadataBatchRequestBody: SetToolMetadataBatchRequestBody,
): string {
  return JSON.stringify(
    SetToolMetadataBatchRequestBody$outboundSchema.parse(
      setToolMetadataBatchRequestBody,
    ),
  );
}
